import { render, staticRenderFns } from "./evaluate-task-teacher.vue?vue&type=template&id=7dd33948&scoped=true"
import script from "./evaluate-task-teacher.vue?vue&type=script&lang=js"
export * from "./evaluate-task-teacher.vue?vue&type=script&lang=js"
import style0 from "./evaluate-task-teacher.vue?vue&type=style&index=0&id=7dd33948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd33948",
  null
  
)

export default component.exports